import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Grand%20Chinese%20national%20brand%20exhibition%20hall%20with%20modern%20architecture%2C%20warm%20golden%20and%20red%20atmosphere%2C%20magnificent%20display%20of%20Chinese%20products%2C%20professional%20wide%20angle%20photography%2C%20bright%20clean%20lighting&width=1920&height=1080&seq=hero-bg-gcdyy-01&orientation=landscape"
          alt="国产第一页 - 中国品牌首选落地页"
          title="国产第一页 - 中国品牌首选落地页"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
            <span className="text-xs md:text-sm text-primary-300 font-medium">汇聚国产精品 助力国货崛起</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            国产第一页
          </h1>
          <p className="text-sm md:text-lg text-background-200 max-w-xl mx-auto mb-8 leading-relaxed">
            中国自主品牌权威导航与推荐平台，专注展示国产品牌的核心价值与竞争优势，
            让每一位用户在国产第一页找到值得信赖的<strong>中国制造</strong>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/keji-shuma"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              探索国产品牌
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-md hover:bg-background-50/20 border border-background-50/30 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              品牌入驻
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}